import { type AnimationData } from '../types';

/**
 * Safely get animation property value with breakpoint suffix fallback.
 *
 * @since ??
 *
 * @param {AnimationData} entry Animation data entry.
 * @param {keyof AnimationData} property Property name (e.g., 'style', 'duration').
 * @param {string} suffix Breakpoint suffix (e.g., '_tablet', '_phone').
 * @returns {string} Property value or fallback.
 */
export const getAnimationProperty = (entry: AnimationData, property: keyof AnimationData, suffix: string): string => {
  if (suffix) {
    const breakpointProperty = `${property}${suffix}`;

    // Use Object.getOwnPropertyDescriptor to safely access dynamic property
    const descriptor = Object.getOwnPropertyDescriptor(entry, breakpointProperty);
    if (descriptor && descriptor.value) {
      // Type guard to ensure value is a string before assignment
      if ('string' === typeof descriptor.value && descriptor.value) {
        return descriptor.value;
      }
    }
  }
  const value = entry[property];
  return value || '';
};
